import React, { PureComponent } from 'react';

import PropTypes from 'prop-types';

import Markdown from 'common/markdown/Markdown';

import PostImages from './PostImages';

import 'css/components/post/_PostBody.scss';

export default class PostBody extends PureComponent {
  static propTypes = {
    post: PropTypes.shape({
      details: PropTypes.string.isRequired,
    }).isRequired,
  };

  renderFeedback() {
    return (
      <div className="details">
        <Markdown contents={this.props.post.details} />
      </div>
    );
  }

  render() {
    const { post } = this.props;

    return (
      <div className="postBody">
        {this.renderFeedback()}
        <PostImages post={post} />
      </div>
    );
  }
}
